import cloneDeep from "clone-deep";
import { useCallback, useContext, useEffect, useState } from "react";
import contextBabylon from "../../../../../context/index.js";
import useComplexState from "../../../../../hooks/useComplexState.js";
import { getTabsProducts as defaultGetTabsProducts } from "../service.js";
const useTabsCarouselProduct = (items, config, getTabsProducts)=>{
    const { BaseUrl =''  } = useContext(contextBabylon);
    const { literals  } = config ?? {};
    const [selectedTab, setSelectedTab] = useState(0);
    const [dataTab, setDataTab] = useState(cloneDeep(items ?? []));
    const { state: tabLoaded , setKeyData: setTabLoaded  } = useComplexState({
        0: !!items?.[selectedTab]?.items
    });
    const setError = useCallback((index, error)=>{
        setDataTab((prev)=>{
            const arr = Array.from(prev);
            if (!(index in arr)) arr[index] = {};
            arr[index].error = {
                error: true,
                errorMessage: error?.errorMessage ?? literals?.messageError ?? literals?.errorComponentMessage
            };
            return arr;
        });
    }, [
        literals?.messageError,
        literals?.errorComponentMessage
    ]);
    const getTabProducts = useCallback(()=>{
        const getTabs = (index)=>getTabsProducts?.(index, BaseUrl) ?? defaultGetTabsProducts(config?.endpoint, items?.[index]?.params ?? [], BaseUrl);
        getTabs(selectedTab).then((data)=>{
            if (!data?.items) {
                setError(selectedTab, data?.error);
                return;
            }
            setDataTab((prev)=>{
                const { items =[] , banner , config , link , error , searcher  } = data;
                const arr = Array.from(prev);
                arr[selectedTab] = {
                    ...arr[selectedTab],
                    items,
                    banner,
                    config,
                    link,
                    error,
                    searcher
                };
                return arr;
            });
        }).catch(()=>setError(selectedTab)).finally(()=>setTabLoaded(selectedTab, true));
    }, [
        selectedTab,
        getTabsProducts,
        BaseUrl,
        config?.endpoint,
        items,
        setError,
        setTabLoaded
    ]);
    useEffect(()=>{
        if (!!dataTab[selectedTab]?.items || !!dataTab[selectedTab]?.error) return;
        getTabProducts();
    }, [
        dataTab,
        selectedTab,
        getTabProducts
    ]);
    return {
        selectedTab,
        dataTab,
        tabLoaded,
        onClickTap: setSelectedTab
    };
};
export default useTabsCarouselProduct;

//# sourceMappingURL=useTabsCarouselProduct.js.map